import {afterNextRender, Injector} from "@angular/core";
import {promiseMedResolvere} from "../../støttefunksjoner/promiser";

/** Utfører angitt callback etter neste oppdatering av GUI */
export function nårGuiErOppdatert<R>(arbeid: () => R, injector: Injector): void {
    afterNextRender({
        read: () => {
            arbeid()
        }
    }, {injector});
}

/** Utfører angitt callback etter neste oppdatering av GUI, returnerer et promise som resolver når arbeid har blitt kjørt */
export function nårGuiErOppdatertSomPromise<R>(arbeid: () => R, injector: Injector): Promise<R> {
    const promise = promiseMedResolvere<R>();
    afterNextRender({
        read: () => {
            promise.resolve(arbeid());
        }
    }, {injector});
    return promise.promise;
}
